export default __webpack_public_path__ + "static/media/sendMessage.32612aed.png";